import OhioHeroSection from "./components/HeroSection";
import OhioCitiesDirectory from "./components/CitiesDirectory";
import OhioStateResources from "./components/StateResources";
import OhioFAQSection, { faqs } from "./components/FAQSection";
import OhioFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const seoFaqs = faqs.map(f => ({ q: f.question, a: f.answer }));

export default function OhioPage() {
  return (
    <>
      <CitySEOHead
        city="Ohio"
        state="Ohio"
        stateAbbr="OH"
        route="/states/ohio"
        title="Ohio Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Ohio — Columbus, Cleveland, Cincinnati, Toledo, Dayton. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Ohio, United States"
        geoPosition="40.4173;-82.9071"
        faqs={seoFaqs}
        servicesSchema={servicesList}
      />
      <div className="font-sans">
        <OhioHeroSection />
        <OhioCitiesDirectory />
        <OhioStateResources />
        <OhioFAQSection />
        <SEOCrossLinks state="OH" />
        <OhioFinalCTA />
      </div>
    </>
  );
}